import classNames from 'classnames';

import { Colors } from '@spotahome/ui-library';

import './EyeIllustration.scss';

const EyeIllustration = ({ className }) => {
  const globoPath =
    'M249.984 0C367.29 0.000177464 466.586 76.6796 499.968 182.39C466.587 288.1 367.29 364.78 249.984 364.78C132.678 364.78 33.3809 288.099 0 182.389C33.3816 76.679 132.679 0 249.984 0Z';

  return (
    <div className={classNames('eye-illustration__container', className)}>
      <div className="eye-illustration__svg-wrapper">
        <svg
          className="eye-illustration__svg"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 500 365"
        >
          <mask id="mask0_1_36" style={{ maskType: 'alpha' }}>
            <path
              d={globoPath}
              fill="white"
              className="eye-illustration__blink"
            />
          </mask>
          <g mask="url(#mask0_1_36)">
            <path
              d={globoPath}
              fill="white"
              className="eye-illustration__blink"
            />
            <ellipse
              cx="249.983"
              cy="182.323"
              fill={Colors.interaction}
              rx="87.4946"
              ry="87.4947"
              className="eye-illustration__pupil"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default EyeIllustration;
